<form #gridForm="ngForm" id="gridForm" (ngSubmit)="saveRow()">
  <mtx-grid
    [cellSelectable]="false"
    [data]="filteredData"
    [columns]="tableColumns"
    [expandable]="expandable"
    [showPaginator]="showPaginator"
    [loading]="isLoading"
    [pageOnFront]="pageOnFront"
    [sortOnFront]="false"
    [sortDisabled]="editObject?.id !== ''"
    [rowHover]="rowHover"
    [multiSelectable]="multiSelectable"
    (rowSelectionChange)="onRowSelectionChange($event)"
    [rowSelectable]="rowSelectable"
    [rowStriped]="true"
    [noResultText]="'table.paginator.noItems' | translate"
    [pageDisabled]="editAllEntries || editObject?.id !== ''"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [length]="totalCount"
    (rowClick)="onRowClick($event)"
    (page)="changePage($event)"
    (sortChange)="changeSort($event)"
    [headerExtraTemplate]="headerExtraTemplate"
    [expansionTemplate]="expansionTemplate"
  >
  </mtx-grid>
  <ng-template #editTemplate let-row let-index="index" let-col="colDef">
    <ng-container *ngIf="row">
      <div class="button-group" *ngIf="row.id !== (editObject?.id ?? '')">
        <button
          mat-icon-button
          [disabled]="(editObject?.id ?? '') !== '' && row.id !== editObject?.id"
          (click)="editRow(row)"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          mat-icon-button
          *ngIf="isDeletable"
          [disabled]="(editObject?.id ?? '') !== '' && row.id !== editObject?.id"
          icon="delete"
          color="warn"
          type="button"
          (click)="deleteRow(row.id)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <div class="button-group" *ngIf="row.id === (editObject?.id ?? '')">
        <button mat-icon-button [disabled]="gridForm.invalid ?? false" type="submit">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="cancelEdit()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #inputTemplate let-row let-index="index" let-col="colDef">
    <div *ngIf="row.id !== (editObject?.id ?? '') && !editAllEntries">
      {{ row[col.field] | translate }}
    </div>
    <div *ngIf="row.id === (editObject?.id ?? '') && !editAllEntries">
      <mat-form-field>
        <input
          #input="ngModel"
          matInput
          [name]="col.field + row.id"
          [required]="col.required"
          [(ngModel)]="editObject[col.field]"
          [type]="col.type"
        />
        <mat-error *ngIf="input.hasError('required')">{{
          'formErrors.required' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
    <div *ngIf="editAllEntries">
      <mat-form-field>
        <input
          #input="ngModel"
          matInput
          [name]="col.field + row.id"
          [required]="col.required"
          [(ngModel)]="editObjects[pageSize * pageIndex * (pageOnFront ? 1 : 0) + index][col.field]"
          [type]="col.type"
        />
        <mat-error *ngIf="input.hasError('required')">{{
          'formErrors.required' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
  </ng-template>

  <ng-template #numberTemplate let-row let-index="index" let-col="colDef">
    <ng-container *ngIf="editAllEntries">
      <ng-container *ngFor="let editItem of editObjects">
        <div *ngIf="row === editItem">
          <mat-form-field>
            <input
              #input="ngModel"
              matInput
              style="text-align: left"
              [name]="col.field + row.id"
              [required]="col.required"
              [(ngModel)]="editItem[col.field]"
              [type]="col.type"
            />
            <mat-error *ngIf="input.hasError('required')">{{
              'formErrors.required' | translate
            }}</mat-error>
          </mat-form-field>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!editAllEntries">
      <div *ngIf="row.id !== (editObject?.id ?? '')" style="width: 100%; text-align: left">
        {{ row[col.field] | number }}
      </div>
      <div *ngIf="row.id === (editObject?.id ?? '')">
        <mat-form-field>
          <input
            #input="ngModel"
            matInput
            style="text-align: left"
            [name]="col.field + row.id"
            [required]="col.required"
            [(ngModel)]="editObject[col.field]"
            [type]="col.type"
          />
          <mat-error *ngIf="input.hasError('required')">{{
            'formErrors.required' | translate
          }}</mat-error>
        </mat-form-field>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #labelTemplate let-row let-index="index" let-col="colDef">
    <div *ngIf="row.id !== (editObject?.id ?? '')">
      {{ row[col.field] | translate }}
    </div>
    <div *ngIf="row.id === (editObject?.id ?? '')">
      {{ editObject[col.field] }}
    </div>
  </ng-template>

  <ng-template #headerTemplate let-col="colDef">
    <div style="display: block; width: 100%" *ngIf="col.headerType === headerColumn.Filter">
      <mat-form-field>
        <input
          #input="ngModel"
          matInput
          [placeholder]="'table.search' | translate"
          [(ngModel)]="filterValues[col.field]"
          (ngModelChange)="filterTable()"
          [disabled]="(editObject?.id ?? '') !== ''"
          [name]="col.field + '_search'"
          type="text"
        />
        <button
          [disabled]="!filterValues[col.field] || (editObject?.id ?? '') !== ''"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="filterValues[col.field] = ''"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div
      style="display: block; width: 100%"
      *ngIf="col.headerType === headerColumn.MultiSelectFilter"
    >
      <mat-form-field>
        <mat-select
          [(ngModel)]="filterValues[col.field]"
          (ngModelChange)="filterTable()"
          multiple
          [name]="col.field + '_search'"
          [disabled]="(editObject?.id ?? '') !== ''"
        >
          <span *ngFor="let option of editSelectOptions">
            <span *ngIf="option.key === col.field">
              <mat-option *ngFor="let item of option.options" [value]="item.id">{{
                item.name | translate
              }}</mat-option>
            </span>
          </span>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="row"
      style="display: flex; width: 100%; margin-top: 1rem"
      *ngIf="col.headerType === headerColumn.ValueType"
    >
      <span class="col-6">BW (kW)</span><span class="col-6">MW (kW)</span>
    </div>
  </ng-template>

  <ng-template #multiSelectTemplate let-row let-index="index" let-col="colDef">
    <div *ngIf="row.id !== (editObject?.id ?? '')">
      <span *ngFor="let option of editSelectOptions">
        <span *ngIf="option.key === col.field">
          <span *ngFor="let item of option.options">
            <span
              class="affinis-chip mat-elevation-z1"
              *ngIf="
                filteredData[pageSize * pageIndex * (pageOnFront ? 1 : 0) + index][
                  col.field
                ]?.includes(item.id)
              "
            >
              {{ item.name }}
            </span>
          </span>
        </span>
      </span>
    </div>
    <div *ngIf="row.id === (editObject?.id ?? '')">
      <mat-form-field>
        <mat-select
          #multiSelect="ngModel"
          multiple
          [(ngModel)]="editObject[col.field]"
          [name]="col.field + row.id"
          [required]="col.required"
        >
          <div *ngIf="!col.dependantSelect">
            <span *ngFor="let option of editSelectOptions">
              <span *ngIf="option.key === col.field">
                <mat-option *ngFor="let item of option.options" [value]="item.id">{{
                  item.name
                }}</mat-option>
              </span>
            </span>
          </div>
          <div *ngIf="col.dependantSelect">
            <mat-option
              *ngFor="let option of dependantEditOptions[row[col.dependantSelectAttribute]]"
              [value]="option.id"
              >{{ option.name }}</mat-option
            >
          </div>
        </mat-select>
        <mat-error *ngIf="multiSelect.hasError('required')">{{
          'formErrors.required' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
  </ng-template>

  <ng-template #selectTemplate let-row let-index="index" let-col="colDef">
    <div *ngIf="row.id !== (editObject?.id ?? '')">
      <span *ngFor="let option of editSelectOptions">
        <span *ngIf="option.key === col.field">
          <span *ngFor="let item of option.options">
            <span
              *ngIf="
                filteredData[pageSize * pageIndex * (pageOnFront ? 1 : 0) + index][col.field] ===
                item.id
              "
            >
              {{ item.name | translate }}
            </span>
          </span>
        </span>
      </span>
    </div>
    <div *ngIf="row.id === (editObject?.id ?? '')">
      <mat-form-field>
        <mat-select
          #select="ngModel"
          [(ngModel)]="editObject[col.field]"
          [name]="col.field + row.id"
          [required]="col.required"
        >
          <div *ngIf="!col.dependantSelect">
            <span *ngFor="let option of editSelectOptions">
              <span *ngIf="option.key === col.field">
                <mat-option *ngFor="let item of option.options" [value]="item.id">{{
                  item.name | translate
                }}</mat-option>
              </span>
            </span>
          </div>
          <div *ngIf="col.dependantSelect">
            <mat-option
              *ngFor="let option of dependantEditOptions[editObject[col.dependantSelectAttribute]]"
              [value]="option.id"
              >{{ option.name }}</mat-option
            >
          </div>
        </mat-select>
        <mat-error *ngIf="select.hasError('required')">{{
          'formErrors.required' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
  </ng-template>

  <ng-template #checkboxTemplate let-row let-index="index" let-col="colDef">
    <div *ngIf="row.id !== (editObject?.id ?? '') && !editAllEntries">
      <mat-checkbox
        disabled
        [name]="col.field + row.id"
        [(ngModel)]="row[col.field]"
      ></mat-checkbox>
    </div>
    <div *ngIf="row.id === (editObject?.id ?? '') && !editAllEntries">
      <mat-checkbox [name]="col.field + row.id" [(ngModel)]="editObject[col.field]"></mat-checkbox>
    </div>
    <div *ngIf="editAllEntries">
      <mat-checkbox
        [name]="col.field + row.id"
        [(ngModel)]="editObjects[pageSize * pageIndex * (pageOnFront ? 1 : 0) + index][col.field]"
      ></mat-checkbox>
    </div>
  </ng-template>
</form>
